import { connect } from 'react-redux';
import Negotiation, { aggregationsProps } from '../../../component/templates/Negotiation';
import { Dispatch } from 'redux';
import { actions } from '@common/redux/modules/Actions';
import { SearchConditionState } from '@common/redux/reducers/SearchConditionReducer';
import { LINE_TYPE, SCREEN, STATUS_TYPE, TAB_TYPE } from '@common/Common';
import { updateAggregations } from '../NegotiationContainerCommons';
import { AgencyAppState } from '../../../redux/modules/store';
import { StoreAndAgencyInfo } from '@common/redux/reducers/StoreSelectorReducer';
import { AnnotationTooltipProps } from '@common/component/molecules/AnnotationTooltip';
import { getAnnotationMasterListFromMasterInfo } from '@common/redux/reducers/MasterInfoReducer';
import ANNOTATION_ID from '@common/redux/reducers/MasterInfoReducer/definitions/AnnotationId';

const mapStateToProps = (appState: AgencyAppState) => {
  const tooltipInfo = getAnnotationMasterListFromMasterInfo(appState.masterInfo, ANNOTATION_ID.ANTT_I_16);

  return {
    userId: appState.loginUser.crewCd,
    isLoggedIn: appState.loginUser.isLoggedIn,
    agencyCd: appState.storeSelector.selectedStores,
    reportTableRow: appState.reportTableRow,
    searchBranchNextAction: appState.searchBranchNextAction,
    searchBranchPending: appState.searchBranchPending,
    searchBranchPeriod: appState.searchBranchPeriod,
    searchBranchProb: appState.searchBranchProb,
    searchBranchResult: appState.searchBranchResult,
    searchBranchStatus: appState.searchBranchStatus,
    searchBranchCommodityCategoryContract: appState.searchBranchCommodityCategoryContract,
    storeSelector: appState.storeSelector,
    header: {
      screenId: SCREEN.DONE_NEGOTIATION.ID,
      screenName: SCREEN.DONE_NEGOTIATION.NAME,
      statusType: STATUS_TYPE.DONE,
      loadingStatus: appState.loadingStatus.doneNegotiation,
    },
    currentFilterCondition: appState.currentFilterCondition,
    filterList: appState.filterList,
    tabContent: [
      {
        tabkey: {
          title: '商談結果別',
          lineType: LINE_TYPE.RESULT,
          type: TAB_TYPE.RESULT,
          url: `${SCREEN.DONE_NEGOTIATION.URL}/${TAB_TYPE.RESULT}`,
        },
        tableCount: appState.negotiationResult,
      },
    ],
    tooltipInfo: {
      content: tooltipInfo.annotationText,
      url: tooltipInfo.linkUrl,
      label: tooltipInfo.linkText,
    } as AnnotationTooltipProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const lineTypes = [LINE_TYPE.RESULT];
  const statusType = STATUS_TYPE.DONE;
  return {
    updateSearchCondition: (searchCondisiton: SearchConditionState) => {
      dispatch(actions.updateSearchCondition(searchCondisiton));
    },
    aggregations: (props: aggregationsProps) => {
      updateAggregations(props, lineTypes, statusType, dispatch);
    },
    updateRefresh: (props: aggregationsProps) => {
      const refresh = () => {
        console.log('current Refresh is Done Negotiation');
        updateAggregations(props, lineTypes, statusType, dispatch);
      };
      dispatch(actions.updateRefresh({ refresh }));
    },
    clearFilter: () => {
      dispatch(actions.clearFilter());
    },
    setToggleModal: () => {
      dispatch(actions.storeSelector.toggleModal());
    },
    setToggleStore: (store: StoreAndAgencyInfo) => {
      store && dispatch(actions.storeSelector.toggleStore(store));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Negotiation);
